// Default pickup location: Zürich Airport (ZRH). All prices originate here.
export const ZURICH_AIRPORT = {
  description: "Flughafen Zürich",
  place_id: "ChIJfXVSQEJ1kEcRWHaIRtZ3a8Y",
};

// Time picker options in 5-minute steps: 00:00, 00:05 … 23:55.
export const TIME_OPTIONS = Array.from({ length: 24 }, (_, h) =>
  Array.from({ length: 12 }, (_, i) => `${String(h).padStart(2, "0")}:${String(i * 5).padStart(2, "0")}`)
).flat();

// Current wall-clock time in Europe/Zurich as a local Date (fields = Zurich time).
// The service is in Zurich and the pickup time is Zurich local time, so we must
// compute defaults/past-checks in Zurich regardless of the visitor's browser TZ.
export function zurichNow() {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Zurich", year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
  }).formatToParts(new Date());
  const o = {};
  parts.forEach((p) => { o[p.type] = p.value; });
  const hour = o.hour === "24" ? 0 : Number(o.hour);
  return new Date(Number(o.year), Number(o.month) - 1, Number(o.day), hour, Number(o.minute), Number(o.second));
}

// Default booking date = today (Zurich); default time = the next valid 5-minute
// slot in the near future (Zurich now + 15 min, rounded up to :05) so the
// customer never starts with a past time. Past times are still blocked at booking.
export function defaultDateTime() {
  const d = zurichNow();
  d.setSeconds(0, 0);
  d.setMinutes(d.getMinutes() + 15);
  const rounded = Math.ceil(d.getMinutes() / 5) * 5;
  d.setMinutes(rounded);
  const date = new Date(d);
  date.setHours(0, 0, 0, 0);
  const time = `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`;
  return { date, time };
}

